import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Airport } from '../models/airport.model';
import { MatDialog } from '@angular/material';
import { AirportService } from '../airport.service';
import { AdminAirportComponent } from '../admin-airport/admin-airport.component';


@Component({
  selector: 'app-airport-flight-deck-button',
  templateUrl: './airport-flight-deck-button.component.html',
  styleUrls: ['./airport-flight-deck-button.component.scss']
})
export class AirportFlightDeckButtonComponent implements OnInit {
  @Input() airport: Airport;
  @Output() airportChange = new EventEmitter<Airport>();

  constructor(private _airportFlightDeckAdminDialog: MatDialog,
              private _airportService: AirportService) { }

  ngOnInit() {
  }

  flightDeckBusinessTools() {
    const dialogRef = this._airportFlightDeckAdminDialog.open(AdminAirportComponent, {
      disableClose: false,
      autoFocus: true,
      width: '50%',
      data: {
        airport: this.airport
      }
    });
    dialogRef.afterClosed().subscribe(async () => {
      this.airport = await this._airportService.getAirport(this.airport.airportId.toString(), true);
      this.airportChange.emit(this.airport);
    });
  }
}
